(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class YGFooter extends HTMLElement {
    connectedCallback() {
      this.toggleButtons.forEach((button) => {
        button.addEventListener('click', this.handleMenuToggle);
      });

      if (this.backTopButton) {
        this.backTopButton.addEventListener('click', this.handleBackTop);
      }
    }

    disconnectedCallback() {
      this.toggleButtons.forEach((button) => {
        button.removeEventListener('click', this.handleMenuToggle);
      });

      if (this.backTopButton) {
        this.backTopButton.removeEventListener('click', this.handleBackTop);
      }
    }

    get toggleButtons() {
      return this.querySelectorAll('[data-footer-menu-toggle]');
    }

    get backTopButton() {
      return this.querySelector('[data-footer-back-top]');
    }

    handleMenuToggle = (event) => {
      if (!window.matchMedia('(max-width: 699px)').matches) {
        return;
      }

      const currentButton = event.currentTarget;
      const shouldExpand = currentButton.getAttribute('aria-expanded') !== 'true';

      this.toggleButtons.forEach((button) => {
        button.setAttribute('aria-expanded', button === currentButton && shouldExpand ? 'true' : 'false');
      });
    };

    handleBackTop = () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    };
  }

  if (!window.customElements.get('yg-footer')) {
    window.customElements.define('yg-footer', YGFooter);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    

  class YGMobileNavigationHeader extends HTMLElement {
    connectedCallback() {
      this.section = document.getElementById(this.getAttribute('section-id'));
      this.drawer = document.getElementById(this.getAttribute('drawer-id'));
      this.header = this.section?.querySelector('.header');
      this.toggleButton = this.header?.querySelector(`[aria-controls="${this.getAttribute('drawer-id')}"]`);

      if (!this.header || !this.drawer || !this.toggleButton) {
        return;
      }

      this.isActive = false;
      this.panelStack = [];
      this.mobileMedia = window.matchMedia('(max-width: 1149px)');
      this.onDrawerClick = this.onDrawerClick.bind(this);
      this.onHeaderToggleClick = this.onHeaderToggleClick.bind(this);
      this.updateState = this.updateState.bind(this);
      this.drawerObserver = new MutationObserver(this.updateState);
      this.toggleObserver = new MutationObserver(this.updateState);

      document.addEventListener('click', this.onHeaderToggleClick, true);
      this.drawer.addEventListener('click', this.onDrawerClick, true);
      this.drawer.addEventListener('dialog:after-hide', this.updateState);
      this.mobileMedia.addEventListener('change', this.updateState);
      this.drawerObserver.observe(this.drawer, {
        attributes: true,
        attributeFilter: ['aria-expanded', 'open'],
        subtree: true
      });
      this.toggleObserver.observe(this.toggleButton, {
        attributes: true,
        attributeFilter: ['aria-expanded']
      });

      this.updateState();
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onHeaderToggleClick, true);
      this.drawer?.removeEventListener('click', this.onDrawerClick, true);
      this.drawer?.removeEventListener('dialog:after-hide', this.updateState);
      this.mobileMedia?.removeEventListener('change', this.updateState);
      this.drawerObserver?.disconnect();
      this.toggleObserver?.disconnect();
    }

    updateState() {
      const isDrawerOpen = this.toggleButton.getAttribute('aria-expanded') === 'true';

      if (!isDrawerOpen || !this.mobileMedia.matches) {
        this.panelStack = [];
      }

      this.renderState();
    }

    renderState() {
      this.isActive = this.mobileMedia.matches && this.panelStack.length > 0;
      this.header.classList.toggle('yg-mobile-panel-active', this.isActive);
    }

    onDrawerClick(event) {
      if (!this.mobileMedia.matches) {
        return;
      }

      const panelButton = event.target.closest('button[data-panel]');

      if (!panelButton || !this.drawer.contains(panelButton)) {
        return;
      }

      const panel = panelButton.getAttribute('data-panel');

      if (panel.includes('-')) {
        this.panelStack.push(panel);
      } else if (panel === '0') {
        this.panelStack = [];
      } else if (panel === '1') {
        this.panelStack.pop();
      }

      this.renderState();
    }

    onHeaderToggleClick(event) {
      if (!this.shouldHandleHeaderBack(event)) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
      this.goBack();
    }

    shouldHandleHeaderBack(event) {
      return this.isActive && this.mobileMedia.matches && this.toggleButton.contains(event.target);
    }

    goBack() {
      const currentPanel = this.panelStack.pop();

      if (!currentPanel || typeof this.drawer.switchToPanel !== 'function') {
        return;
      }

      const currentLevel = Number.parseInt(currentPanel.split('-')[0], 10);
      const previousLevel = String(Math.max(0, currentLevel - 1));
      this.renderState();
      this.drawer.switchToPanel(previousLevel);
    }
  }

  if (!customElements.get('yg-mobile-navigation-header')) {
    customElements.define('yg-mobile-navigation-header', YGMobileNavigationHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-featured-collection"] && !Shopify.designMode) return;
  try {
    
  class YGFeaturedCollectionSwiper extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
    }

    connectedCallback() {
      if (this.swiper || typeof Swiper === 'undefined') {
        return;
      }

      const swiperId = this.dataset.id;
      const mobileSlides = Number(this.dataset.mobileSlides) || 2;
      const mobileGroup = Number(this.dataset.mobileGroup) || 4;
      const mobileRows = Number(this.dataset.mobileRows) || 2;
      const tabletSlides = Number(this.dataset.tabletSlides) || 2;
      const desktopSlides = Number(this.dataset.desktopSlides) || 5;
      const paginationType = this.dataset.paginationType || 'bullets';

      this.swiper = new Swiper(this, {
        slidesPerView: mobileSlides,
        slidesPerGroup: mobileGroup,
        grid: {
          rows: mobileRows,
          fill: 'row'
        },
        spaceBetween: 10,
        pagination: {
          el: `.${swiperId}-pagination`,
          type: paginationType,
          clickable: true
        },
        navigation: {
          nextEl: `.${swiperId}-next`,
          prevEl: `.${swiperId}-prev`
        },
        breakpoints: {
          700: {
            slidesPerView: tabletSlides,
            slidesPerGroup: tabletSlides,
            grid: {
              rows: 1
            },
            spaceBetween: 24
          },
          1000: {
            slidesPerView: desktopSlides,
            slidesPerGroup: desktopSlides,
            grid: {
              rows: 1
            },
            spaceBetween: 12
          }
        }
      });
    }

    disconnectedCallback() {
      if (!this.swiper) {
        return;
      }

      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  if (!customElements.get('yg-featured-collection-swiper')) {
    customElements.define('yg-featured-collection-swiper', YGFeaturedCollectionSwiper);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-multi-column-01"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGSwiperCard extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
      }
      connectedCallback() {
        // 避免多次初始化
        if (this.swiper) return;

        this.swiper = this.initSwiper(this);
      }
    }
    if (!customElements.get('yg-swiper-card')) {
      customElements.define('yg-swiper-card', YGSwiperCard);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-process-steps-v3"] && !Shopify.designMode) return;
  try {
    
  class YGProcessStepsV3 extends HTMLElement {
    constructor() {
      super();
      this.currentIndex = -1;
      this.handleStepClick = this.handleStepClick.bind(this);
      this.handleStepKeydown = this.handleStepKeydown.bind(this);
      this.handleAnimationEnd = this.handleAnimationEnd.bind(this);
      this.handleMobileSlideChange = this.handleMobileSlideChange.bind(this);
      this.handleViewportChange = this.handleViewportChange.bind(this);
    }

    connectedCallback() {
      this.steps = Array.from(this.querySelectorAll('.yg-process-steps-v3__step'));
      this.desktopSteps = Array.from(this.querySelectorAll('.yg-process-steps-v3__desktop .yg-process-steps-v3__step'));
      this.panels = Array.from(this.querySelectorAll('.yg-process-steps-v3__media-panel'));
      this.mobileTabs = Array.from(this.querySelectorAll('.yg-process-steps-v3__mobile-tab'));
      this.mobileSwiper = this.querySelector('.yg-process-steps-v3__mobile-swiper');
      this.mediaQuery = window.matchMedia('(max-width: 699px)');
      this.isAutoplay = this.dataset.autoplay === 'true';
      this.leaveTimeout = null;

      this.steps.forEach((step) => {
        step.addEventListener('click', this.handleStepClick);
        step.addEventListener('keydown', this.handleStepKeydown);
      });

      this.desktopSteps.forEach((step) => {
        step.querySelector('.yg-process-steps-v3__bar')?.addEventListener('animationend', this.handleAnimationEnd);
      });

      this.addViewportListener();
      this.setActive(0);
      window.setTimeout(() => {
        this.bindMobileSwiper();
        this.handleViewportChange();
      });
    }

    disconnectedCallback() {
      this.steps?.forEach((step) => {
        step.removeEventListener('click', this.handleStepClick);
        step.removeEventListener('keydown', this.handleStepKeydown);
      });
      this.desktopSteps?.forEach((step) => {
        step.querySelector('.yg-process-steps-v3__bar')?.removeEventListener('animationend', this.handleAnimationEnd);
      });
      this.mobileSwiper?.swiper?.off('slideChange', this.handleMobileSlideChange);
      this.removeViewportListener();
      window.clearTimeout(this.leaveTimeout);
    }

    handleStepClick(event) {
      const index = Number(event.currentTarget.dataset.index);
      this.setActive(index);
      this.slideMobileSwiper(index);
    }

    handleStepKeydown(event) {
      if (event.key !== 'Enter' && event.key !== ' ') {
        return;
      }

      event.preventDefault();
      const index = Number(event.currentTarget.dataset.index);
      this.setActive(index);
      this.slideMobileSwiper(index);
    }

    handleAnimationEnd(event) {
      if (!this.isAutoplay || this.isMobileMode() || !event.target.closest('.is-active')) {
        return;
      }

      this.setActive(this.getNextIndex());
    }

    handleMobileSlideChange() {
      if (!this.isMobileMode()) {
        return;
      }

      const swiper = this.mobileSwiper?.swiper;
      const index = Number(swiper?.realIndex ?? swiper?.activeIndex);
      this.setActive(index);
    }

    handleViewportChange() {
      if (this.isMobileMode()) {
        this.slideMobileSwiper(this.currentIndex);
      }
    }

    addViewportListener() {
      if (this.mediaQuery?.addEventListener) {
        this.mediaQuery.addEventListener('change', this.handleViewportChange);
        return;
      }

      this.mediaQuery?.addListener?.(this.handleViewportChange);
    }

    removeViewportListener() {
      if (this.mediaQuery?.removeEventListener) {
        this.mediaQuery.removeEventListener('change', this.handleViewportChange);
        return;
      }

      this.mediaQuery?.removeListener?.(this.handleViewportChange);
    }

    isMobileMode() {
      return this.mediaQuery?.matches;
    }

    bindMobileSwiper() {
      if (!this.mobileSwiper?.swiper) {
        return;
      }

      this.mobileSwiper.swiper.off('slideChange', this.handleMobileSlideChange);
      this.mobileSwiper.swiper.on('slideChange', this.handleMobileSlideChange);
    }

    getNextIndex() {
      const count = this.panels.length;
      return count > 0 ? (this.currentIndex + 1) % count : 0;
    }

    restartAnimation(element, selector) {
      const animatedElement = element?.querySelector(selector);
      if (!animatedElement) {
        return;
      }

      animatedElement.style.animation = 'none';
      animatedElement.offsetHeight;
      animatedElement.style.animation = '';
    }

    slideMobileSwiper(index) {
      const swiper = this.mobileSwiper?.swiper;
      if (!swiper) {
        return;
      }

      if (typeof swiper.slideToLoop === 'function') {
        swiper.slideToLoop(index);
        return;
      }

      swiper.slideTo(index);
    }

    syncPanelState(index, previousIndex) {
      const count = this.panels.length;
      const nextIndex = count > 0 ? (index + 1) % count : -1;
      const afterNextIndex = count > 0 ? (index + 2) % count : -1;
      const hasPrevious = previousIndex !== undefined && previousIndex !== index;

      window.clearTimeout(this.leaveTimeout);

      this.panels.forEach((panel, panelIndex) => {
        const isLeaving = hasPrevious && panelIndex === previousIndex;

        panel.classList.remove('is-entering');
        panel.classList.toggle('is-active', panelIndex === index);
        panel.classList.toggle('is-leaving', isLeaving);
        panel.classList.toggle('is-next', !isLeaving && count > 1 && panelIndex === nextIndex);
        panel.classList.toggle('is-after-next', !isLeaving && count > 2 && panelIndex === afterNextIndex);
        panel.setAttribute('aria-hidden', panelIndex === index ? 'false' : 'true');
      });

      if (hasPrevious) {
        this.panels[index]?.classList.add('is-entering');
        this.leaveTimeout = window.setTimeout(() => {
          this.panels.forEach((panel) => {
            panel.classList.remove('is-leaving', 'is-entering');
          });
          this.syncPanelState(this.currentIndex);
        }, 720);
      }
    }

    setActive(index) {
      if (Number.isNaN(index)) {
        return;
      }

      const count = this.panels.length;
      if (count === 0) {
        return;
      }

      index = ((index % count) + count) % count;

      if (index === this.currentIndex && this.panels?.[index]?.classList.contains('is-active')) {
        return;
      }

      const previousIndex = this.currentIndex;
      this.currentIndex = index;
      this.steps.forEach((step) => {
        const stepIndex = Number(step.dataset.index);
        const isActive = stepIndex === index;
        step.classList.toggle('is-active', isActive);
        step.setAttribute('aria-selected', isActive ? 'true' : 'false');
        if (isActive) {
          this.restartAnimation(step, '.yg-process-steps-v3__bar');
        }
      });

      this.syncPanelState(index, previousIndex);
    }
  }

  if (!window.customElements.get('yg-process-steps-v3')) {
    window.customElements.define('yg-process-steps-v3', YGProcessStepsV3);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-product-compare-v3"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // 让 Vue 忽略以 yg- 开头的自定义标签（如 yg-image、yg-select 等），避免 Unknown custom element 报错
    if (window.Vue && Vue.config) {
      Vue.config.ignoredElements = Vue.config.ignoredElements || [];
      Vue.config.ignoredElements.push(/^yg-/);
    }

    class YGProductCompareV3 extends HTMLElement {
      constructor() {
        super();
        this.handleClick = this.handleClick.bind(this);
        this.handleWindowScroll = this.handleWindowScroll.bind(this);
        this.handleResize = this.handleResize.bind(this);
        this.handleTopBarScroll = this.handleTopBarScroll.bind(this);
        this.handleFloatingTopBarScroll = this.handleFloatingTopBarScroll.bind(this);
        this.handleTopScroll = this.handleTopScroll.bind(this);
        this.handleDataScroll = this.handleDataScroll.bind(this);
      }
      get isFloatingTopBarEnabled() {
        return this.dataset.enableFloatingTopBar === 'true';
      }
      get sectionsEl() {
        if (this._sectionsEl) return this._sectionsEl;
        this._sectionsEl = {
          'product-form': this.querySelector('#yg-product-form') || this.querySelector('.yg-product-form'),
          'product-form-id': this.querySelector('#yg-product-form-id') || this.querySelector('.yg-product-form-id'),
          'product-data': this.querySelector('.yg-product-data'),
          'product-top-bar-shell': this.querySelector('.yg-product-top-bar-shell'),
          'product-top-bar-scroll': this.querySelector('.yg-product-compare-top-bar-container'),
          'floating-top-bar-shell': this.querySelector('.yg-product-floating-top-bar-shell'),
          'floating-top-bar-scroll': this.querySelector('.yg-product-floating-top-bar-container'),
          'product-top-scroll': this.querySelector('.yg-product-compare-top-container'),
          'product-data-scroll': this.querySelector('.yg-product-compare-data-container'),
        };

        return this._sectionsEl;
      }
      connectedCallback() {
        this.initVue();

        if (!this._eventsBound) {
          this.addEventListener('click', this.handleClick);
          window.addEventListener('resize', this.handleResize);
          this.sectionsEl['product-top-bar-scroll']?.addEventListener('scroll', this.handleTopBarScroll, {
            passive: true,
          });
          this.sectionsEl['product-top-scroll']?.addEventListener('scroll', this.handleTopScroll, { passive: true });
          this.sectionsEl['product-data-scroll']?.addEventListener('scroll', this.handleDataScroll, { passive: true });
          if (this.isFloatingTopBarEnabled) {
            window.addEventListener('scroll', this.handleWindowScroll, { passive: true });
            this.sectionsEl['floating-top-bar-scroll']?.addEventListener('scroll', this.handleFloatingTopBarScroll, {
              passive: true,
            });
          }
          this._eventsBound = true;
        }

        this.handleResize();
        this.refreshDynamicHeights();
        if (this.isFloatingTopBarEnabled) {
          this.requestFloatingNavStateUpdate();
        }
      }
      disconnectedCallback() {
        if (!this._eventsBound) return;

        this.removeEventListener('click', this.handleClick);
        window.removeEventListener('resize', this.handleResize);
        this.sectionsEl['product-top-bar-scroll']?.removeEventListener('scroll', this.handleTopBarScroll);
        this.sectionsEl['product-top-scroll']?.removeEventListener('scroll', this.handleTopScroll);
        this.sectionsEl['product-data-scroll']?.removeEventListener('scroll', this.handleDataScroll);
        if (this.isFloatingTopBarEnabled) {
          window.removeEventListener('scroll', this.handleWindowScroll);
          this.sectionsEl['floating-top-bar-scroll']?.removeEventListener('scroll', this.handleFloatingTopBarScroll);
          this.closeTopBarDropdowns();
        }
        if (this._floatingNavFrame) {
          cancelAnimationFrame(this._floatingNavFrame);
          this._floatingNavFrame = null;
        }
        this._eventsBound = false;
      }
      initVue() {
        if (this._vue) return;

        if (!window.Vue || !window.ELEMENT) {
          console.warn('[yg-product-compare-v3] Vue or Element UI is not available.');
          return;
        }

        let _this = this;
        this._vue = new Vue({
          el: _this.querySelector('.yg-select-vue'),
          delimiters: ['${', '}'],
          data() {
            let initialState = {
              options: [],
              values: [],
              hideDuplicates: false,
              primaryRowCount: 0,
              groupRowCounts: {},
              isCondensedLayout: false,
              variantsCurrent: [
                { id: null, price: null, featured_image: null, available: null },
                { id: null, price: null, featured_image: null, available: null },
                { id: null, price: null, featured_image: null, available: null },
              ],
            };

            const textarea = _this.querySelector('#compare-data');
            if (textarea) {
              const raw = (textarea.value || textarea.textContent || '').trim();
              if (raw) {
                let parsed;
                try {
                  parsed = JSON.parse(raw);
                } catch (error) {
                  parsed = new Function('return ' + raw)();
                }
                if (parsed && Array.isArray(parsed.options)) {
                  initialState.options = parsed.options;
                }

                initialState.values = initialState.options.slice(0, 3).map((opt) => opt.value);
                initialState.variantsCurrent = [];
                initialState.values.forEach((handle) => {
                  const opt = initialState.options.find((option) => option && option.value === handle);
                  const variants = opt && opt.data && Array.isArray(opt.data.variants) ? opt.data.variants : [];
                  const firstVariant = variants[0] || null;
                  initialState.variantsCurrent.push({
                    id: firstVariant ? firstVariant.id : null,
                    price: firstVariant ? firstVariant.price : null,
                    featured_image:
                      firstVariant && firstVariant.featured_image ? firstVariant.featured_image.src : null,
                    available: firstVariant ? firstVariant.available : null,
                  });
                });

                while (initialState.variantsCurrent.length < 3) {
                  initialState.variantsCurrent.push({
                    id: null,
                    price: null,
                    featured_image: null,
                    available: null,
                  });
                }
              }
            }

            return initialState;
          },
          mounted() {
            this.primaryRowCount = _this.querySelectorAll('.yg-product-data-group > .row').length;

            const groupRowCounts = {};
            _this.querySelectorAll('.yg-product-dropdown-wrap').forEach((groupWrap) => {
              const groupIndex = Number(groupWrap.dataset.groupIndex);
              if (Number.isNaN(groupIndex)) return;
              groupRowCounts[groupIndex] = groupWrap.querySelectorAll('.row').length;
            });
            this.groupRowCounts = groupRowCounts;

            _this.syncResponsiveState();
            this.handleSpecificationVisibilityChange();
          },
          watch: {
            hideDuplicates() {
              this.handleSpecificationVisibilityChange();
            },
            values: {
              deep: true,
              handler() {
                this.handleSpecificationVisibilityChange();
              },
            },
            isCondensedLayout() {
              this.handleSpecificationVisibilityChange();
            },
          },
          methods: {
            formatMoney(cents) {
              const format = _this.getAttribute('data-currency-format');
              const valueNumber = Number(cents) || 0;
              const amount = valueNumber / 100;
              const amountStr = amount.toFixed(2);
              return format + amountStr;
            },
            handleProductChange(columnIndex, newColumnValue) {
              const variants = (this.variantsMap && this.variantsMap[newColumnValue]) || [];
              const nextVariant = variants[0] || null;
              const nextId = nextVariant ? nextVariant.id : null;

              this.$set(this.variantsCurrent, columnIndex, {
                id: nextId,
                price: nextVariant ? nextVariant.price : null,
                featured_image: nextVariant && nextVariant.featured_image ? nextVariant.featured_image.src : null,
                available: nextVariant ? nextVariant.available : null,
              });
              if (nextId != null) this.handleVariantChange(newColumnValue, nextId, columnIndex);
            },
            handleVariantChange(columnValue, variantId, columnIndex) {
              const variants = (this.variantsMap && this.variantsMap[columnValue]) || [];
              const selected = variants.find((variant) => variant && String(variant.id) === String(variantId)) || null;
              const price = selected ? selected.price : null;
              const featuredImage = selected && selected.featured_image ? selected.featured_image.src : null;
              const available = selected ? selected.available : null;

              if (typeof columnIndex === 'number') {
                const previous = (this.variantsCurrent && this.variantsCurrent[columnIndex]) || {};
                this.$set(this.variantsCurrent, columnIndex, {
                  ...previous,
                  id: variantId,
                  price,
                  featured_image: featuredImage,
                  available,
                });
              }
            },
            getVariantOptionValue(columnValue, item) {
              const position = (this.variantPositionMap && this.variantPositionMap[columnValue]) || 1;
              const key = 'option' + String(position);
              return (item && item[key]) || (item && item.public_title) || '';
            },
            getVariantLabel(columnValue, item) {
              const value = this.getVariantOptionValue(columnValue, item);
              return value || (item && item.public_title) || '';
            },
            getColorSwatchStyle(columnValue, item) {
              const value = this.getVariantOptionValue(columnValue, item);
              const key = String(value || '')
                .toLowerCase()
                .trim();
              const map = (this.colorSwatchMap && this.colorSwatchMap[columnValue]) || {};
              return map[key] || '';
            },
            buildMapFromOptions(getValueFn) {
              const map = {};
              (this.options || []).forEach((option) => {
                if (!option || option.value == null) return;
                const value = getValueFn(option);
                if (value != null) {
                  map[option.value] = value;
                }
              });
              return map;
            },
            normalizeComparableValue(value) {
              if (value == null) return '';
              return String(value).trim();
            },
            getVisibleColumnIndices() {
              const maxCount = this.isCondensedLayout ? 2 : Math.min(this.values.length, 3);
              return this.values
                .slice(0, maxCount)
                .map((_, index) => index)
                .filter((index) => this.values[index]);
            },
            shouldHideComparableValues(values) {
              if (!this.hideDuplicates || values.length < 2) return false;
              const firstValue = values[0];
              return values.every((value) => value === firstValue);
            },
            getPrimaryRowComparableValue(columnIndex, rowIndex) {
              const handle = this.values[columnIndex];
              if (!handle) return '';
              const imageValue = (this.specificationImageMap[handle] || [])[rowIndex] || '';
              const textValue = (this.specificationListMap[handle] || [])[rowIndex] || '';
              return [this.normalizeComparableValue(imageValue), this.normalizeComparableValue(textValue)].join('||');
            },
            shouldHidePrimaryRow(rowIndex) {
              const rowValues = this.getVisibleColumnIndices().map((columnIndex) =>
                this.getPrimaryRowComparableValue(columnIndex, rowIndex)
              );
              return this.shouldHideComparableValues(rowValues);
            },
            getGroupSpecificationMap(groupIndex) {
              const groupMaps = {
                1: this.specificationListGroup1Map,
                2: this.specificationListGroup2Map,
                3: this.specificationListGroup3Map,
                4: this.specificationListGroup4Map,
                5: this.specificationListGroup5Map,
              };
              return groupMaps[groupIndex] || {};
            },
            getGroupRowDisplayValue(groupIndex, columnIndex, rowIndex) {
              const handle = this.values[columnIndex];
              if (!handle) return '';
              const groupMap = this.getGroupSpecificationMap(groupIndex);
              const rawValue = (groupMap[handle] || [])[rowIndex];
              if (rawValue === '.') return '.';
              if (rawValue == null || rawValue === '') return '-';
              return this.normalizeComparableValue(rawValue);
            },
            shouldHideGroupRow(groupIndex, rowIndex) {
              const rowValues = this.getVisibleColumnIndices().map((columnIndex) =>
                this.getGroupRowDisplayValue(groupIndex, columnIndex, rowIndex)
              );
              return this.shouldHideComparableValues(rowValues);
            },
            isGroupFullyHidden(groupIndex, rowCount) {
              if (!this.hideDuplicates) return false;
              const totalRows = Number(rowCount) || 0;
              if (totalRows === 0) return true;

              for (let rowIndex = 0; rowIndex < totalRows; rowIndex += 1) {
                if (!this.shouldHideGroupRow(groupIndex, rowIndex)) {
                  return false;
                }
              }

              return true;
            },
            hasVisiblePrimaryRows() {
              const totalRows = Number(this.primaryRowCount) || 0;
              for (let rowIndex = 0; rowIndex < totalRows; rowIndex += 1) {
                if (!this.shouldHidePrimaryRow(rowIndex)) {
                  return true;
                }
              }

              return false;
            },
            hasVisibleGroupedRows() {
              const groupRowCounts = this.groupRowCounts || {};
              return Object.keys(groupRowCounts).some((groupIndex) => {
                return !this.isGroupFullyHidden(Number(groupIndex), groupRowCounts[groupIndex]);
              });
            },
            handleSpecificationVisibilityChange() {
              this.$nextTick(() => {
                _this.refreshDynamicHeights();
              });
            },
          },
          computed: {
            imageMap() {
              return this.buildMapFromOptions((option) => option.data && option.data.product_image);
            },
            productTitleMap() {
              return this.buildMapFromOptions((option) => option.label);
            },
            variantsMap() {
              return this.buildMapFromOptions((option) => option.data && option.data.variants);
            },
            variantPositionMap() {
              return this.buildMapFromOptions((option) => option.data && option.data.variant_position);
            },
            colorSwatchMap() {
              return this.buildMapFromOptions((option) => {
                const rows =
                  option && option.data && Array.isArray(option.data.color_swatch_config)
                    ? option.data.color_swatch_config
                    : [];
                const map = {};
                rows.forEach((row) => {
                  if (!row || row.label == null) return;
                  const key = String(row.label).toLowerCase().trim();
                  const value = row.value;
                  if (key && value) map[key] = value;
                });
                return map;
              });
            },
            specificationImageMap() {
              return this.buildMapFromOptions((option) => option.data && option.data.specification_image);
            },
            specificationListMap() {
              return this.buildMapFromOptions((option) => option.data && option.data.specification_list);
            },
            minPriceMap() {
              return this.buildMapFromOptions((option) => option.min_price);
            },
            productUrlMap() {
              return this.buildMapFromOptions((option) => option.product_url);
            },
            specificationListGroup1Map() {
              return this.buildMapFromOptions((option) => option.data && option.data.specification_list_group_1);
            },
            specificationListGroup2Map() {
              return this.buildMapFromOptions((option) => option.data && option.data.specification_list_group_2);
            },
            specificationListGroup3Map() {
              return this.buildMapFromOptions((option) => option.data && option.data.specification_list_group_3);
            },
            specificationListGroup4Map() {
              return this.buildMapFromOptions((option) => option.data && option.data.specification_list_group_4);
            },
            specificationListGroup5Map() {
              return this.buildMapFromOptions((option) => option.data && option.data.specification_list_group_5);
            },
            hasVisibleComparisonData() {
              return this.hasVisiblePrimaryRows() || this.hasVisibleGroupedRows();
            },
          },
        });
      }
      handleClick(event) {
        const addButton =
          event.target && event.target.closest ? event.target.closest('.yg-product-button-add-to-cart') : null;
        if (!addButton || !this.contains(addButton)) return;

        event.preventDefault?.();
        this.handleAddToCart(addButton);
      }
      handleResize() {
        this.syncResponsiveState();
        this.refreshDynamicHeights();
        if (this.isFloatingTopBarEnabled) {
          this.requestFloatingNavStateUpdate();
        }
      }
      handleWindowScroll() {
        if (!this.isFloatingTopBarEnabled) return;
        this.requestFloatingNavStateUpdate();
      }
      handleTopBarScroll() {
        const targetKeys = this.isFloatingTopBarEnabled
          ? ['floating-top-bar-scroll', 'product-top-scroll', 'product-data-scroll']
          : ['product-top-scroll', 'product-data-scroll'];
        this.syncScroll('product-top-bar-scroll', targetKeys);
      }
      handleFloatingTopBarScroll() {
        if (!this.isFloatingTopBarEnabled) return;
        this.syncScroll('floating-top-bar-scroll', [
          'product-top-bar-scroll',
          'product-top-scroll',
          'product-data-scroll',
        ]);
      }
      handleTopScroll() {
        const targetKeys = this.isFloatingTopBarEnabled
          ? ['product-top-bar-scroll', 'floating-top-bar-scroll', 'product-data-scroll']
          : ['product-top-bar-scroll', 'product-data-scroll'];
        this.syncScroll('product-top-scroll', targetKeys);
      }
      handleDataScroll() {
        const targetKeys = this.isFloatingTopBarEnabled
          ? ['product-top-bar-scroll', 'floating-top-bar-scroll', 'product-top-scroll']
          : ['product-top-bar-scroll', 'product-top-scroll'];
        this.syncScroll('product-data-scroll', targetKeys);
      }
      syncScroll(sourceKey, targetKeys) {
        const source = this.sectionsEl[sourceKey];
        const nextTargetKeys = Array.isArray(targetKeys) ? targetKeys : [targetKeys];

        if (!source || this._syncingScroll) return;

        this._syncingScroll = true;
        nextTargetKeys.forEach((targetKey) => {
          const target = this.sectionsEl[targetKey];
          if (!target || target === source) return;
          if (target.scrollLeft === source.scrollLeft) return;
          target.scrollLeft = source.scrollLeft;
        });
        requestAnimationFrame(() => {
          this._syncingScroll = false;
        });
      }
      syncResponsiveState() {
        if (!this._vue) return;

        const isCondensedLayout =
          this.classList.contains('show-product-select') && window.matchMedia('(max-width: 1150px)').matches;
        this._vue.isCondensedLayout = isCondensedLayout;
      }
      closeTopBarDropdowns() {
        this.querySelectorAll('.yg-product-select').forEach((selectEl) => {
          const instance = selectEl.__vue__;
          if (!instance) return;

          if (typeof instance.blur === 'function') {
            instance.blur();
          }

          if ('visible' in instance) {
            instance.visible = false;
          }
        });

        const sectionId = this.dataset.sectionId;
        if (!sectionId) return;

        document.querySelectorAll(`.yg-product-compare-top-popper-${sectionId}`).forEach((popper) => {
          popper.style.display = 'none';
          popper.setAttribute('aria-hidden', 'true');
        });
      }
      getFloatingNavTopOffset() {
        const styles = getComputedStyle(this);
        const headerHeightValue = parseFloat(styles.getPropertyValue('--header-height'));
        const headerVisibleValue = parseFloat(styles.getPropertyValue('--header-is-visible'));
        const headerHeight = Number.isFinite(headerHeightValue) ? headerHeightValue : 0;
        const headerVisible = Number.isFinite(headerVisibleValue) ? headerVisibleValue : 1;
        return Math.max(0, (headerHeight - 1.5) * headerVisible);
      }
      requestFloatingNavStateUpdate() {
        if (!this.isFloatingTopBarEnabled) return;
        if (this._floatingNavFrame) return;

        this._floatingNavFrame = requestAnimationFrame(() => {
          this._floatingNavFrame = null;
          this.updateFloatingNavState();
        });
      }
      updateFloatingNavState() {
        if (!this.isFloatingTopBarEnabled) return;
        const floatingShell = this.sectionsEl['floating-top-bar-shell'];
        const sourceShell = this.sectionsEl['product-top-bar-shell'];
        const sourceScroll = this.sectionsEl['product-top-bar-scroll'];
        if (!floatingShell || !sourceShell || !sourceScroll) return;

        const stickyTop = this.getFloatingNavTopOffset();
        const sectionRect = this.getBoundingClientRect();
        const sourceShellRect = sourceShell.getBoundingClientRect();
        const sourceScrollRect = sourceScroll.getBoundingClientRect();
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;

        const isSectionVisible = sectionRect.top < viewportHeight && sectionRect.bottom > stickyTop;
        const hasSourceBarScrolledOut = sourceShellRect.bottom <= stickyTop;
        const shouldShowFloating = isSectionVisible && hasSourceBarScrolledOut;
        const wasFloatingActive = floatingShell.classList.contains('is-active');

        this.style.setProperty('--floating-nav-top', `${stickyTop}px`);
        this.style.setProperty('--floating-nav-left', `${sourceScrollRect.left}px`);
        this.style.setProperty('--floating-nav-width', `${sourceScrollRect.width}px`);

        if (wasFloatingActive !== shouldShowFloating) {
          this.closeTopBarDropdowns();
        }

        floatingShell.classList.toggle('is-active', shouldShowFloating);
        floatingShell.setAttribute('aria-hidden', shouldShowFloating ? 'false' : 'true');
      }
      refreshDynamicHeights() {
        requestAnimationFrame(() => {
          this.syncDropdownHeights();
          this.refreshCollapseButtons();
          const productData = this.sectionsEl['product-data'];
          if (productData && productData.hasAttribute('open')) {
            productData.style.height = 'auto';
          }
          if (this.isFloatingTopBarEnabled) {
            this.requestFloatingNavStateUpdate();
          }
        });
      }
      syncDropdownHeights() {
        this.querySelectorAll('yg-dropdown').forEach((dropdown) => {
          dropdown.setContentContainerHeight?.();
        });
      }
      refreshCollapseButtons() {
        this.querySelectorAll('yg-collapse-button').forEach((button) => {
          button.refresh?.();
        });
      }
      handleAddToCart(item) {
        const variantId = item?.dataset?.variantId || item?.getAttribute?.('data-variant-id');

        if (!variantId && !item.classList.contains('disabled')) return;

        const form = this.sectionsEl['product-form'];
        const idInput = this.sectionsEl['product-form-id'];
        if (!form || !idInput) return;

        idInput.value = String(variantId);
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
        idInput.dispatchEvent(new Event('input', { bubbles: true }));

        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
          return;
        }

        const submitBtn = form.querySelector('[type="submit"]');
        if (submitBtn && typeof submitBtn.click === 'function') {
          submitBtn.click();
          return;
        }

        form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }
    }
    if (!window.customElements.get('yg-product-compare-v3')) {
      window.customElements.define('yg-product-compare-v3', YGProductCompareV3);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-splash-screen-animation"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('yg-splash-screen-v2')) {
    class YGSplashScreen extends HTMLElement {
      connectedCallback() {
        this.overlay = this.querySelector('.yg-splash-screen__overlay');
        this.handleOverlayEnd = this.handleOverlayEnd.bind(this);
        this.startDelayTimer = null;
        this.scrollUnlockTimer = null;
        this.animationFallback = null;
        this.isScrollLocked = false;

        if (this.dataset.hasOverlay !== 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.showFinalState();
          return;
        }

        this.overlay?.addEventListener('animationend', this.handleOverlayEnd);
        this.overlay?.addEventListener('animationcancel', this.handleOverlayEnd);
        this.startWhenImagesAreReady();
      }

      disconnectedCallback() {
        this.overlay?.removeEventListener('animationend', this.handleOverlayEnd);
        this.overlay?.removeEventListener('animationcancel', this.handleOverlayEnd);
        window.clearTimeout(this.startDelayTimer);
        window.clearTimeout(this.scrollUnlockTimer);
        window.clearTimeout(this.animationFallback);
        this.unlockScroll();
      }

      async startWhenImagesAreReady() {
        const images = Array.from(this.querySelectorAll('img')).filter((image) => {
          return window.getComputedStyle(image).display !== 'none';
        });

        await Promise.all(images.map((image) => this.waitForImage(image)));

        if (!this.isConnected) {
          return;
        }

        const startDelay = Number.parseFloat(this.dataset.startDelay) || 0;
        this.startDelayTimer = window.setTimeout(() => this.startAnimation(), startDelay * 1000);
      }

      startAnimation() {
        if (!this.isConnected) {
          return;
        }

        if (!this.isInViewport()) {
          this.showFinalState();
          return;
        }

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            if (!this.isConnected || !this.isInViewport()) {
              this.showFinalState();
              return;
            }

            this.lockScroll();
            this.classList.add('is-ready');

            const duration = Number.parseFloat(this.dataset.overlayDuration) || 0;
            const scrollLockDuration = Math.max(0, duration - 1);
            this.scrollUnlockTimer = window.setTimeout(() => this.unlockScroll(), scrollLockDuration * 1000);
            this.animationFallback = window.setTimeout(() => this.showFinalState(), duration * 1000);
          });
        });
      }

      isInViewport() {
        const rect = this.getBoundingClientRect();
        return rect.bottom > 0 && rect.top < window.innerHeight;
      }

      waitForImage(image) {
        if (image.complete && !image.hasAttribute('data-src')) {
          return Promise.resolve();
        }

        return new Promise((resolve) => {
          image.addEventListener('load', resolve, { once: true });
          image.addEventListener('error', resolve, { once: true });
        });
      }

      handleOverlayEnd(event) {
        if (event.target !== this.overlay) {
          return;
        }

        this.showFinalState();
      }

      showFinalState() {
        window.clearTimeout(this.scrollUnlockTimer);
        window.clearTimeout(this.animationFallback);
        this.classList.add('is-ready', 'is-complete');
        this.unlockScroll();
      }

      lockScroll() {
        if (this.isScrollLocked) {
          return;
        }

        this.isScrollLocked = true;
        this.scrollY = window.scrollY;
        this.htmlOverflow = document.documentElement.style.overflow;
        this.bodyOverflow = document.body.style.overflow;
        this.bodyPosition = document.body.style.position;
        this.bodyTop = document.body.style.top;
        this.bodyWidth = document.body.style.width;

        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.top = `-${this.scrollY}px`;
        document.body.style.width = '100%';
      }

      unlockScroll() {
        if (!this.isScrollLocked) {
          return;
        }

        this.isScrollLocked = false;
        document.documentElement.style.overflow = this.htmlOverflow;
        document.body.style.overflow = this.bodyOverflow;
        document.body.style.position = this.bodyPosition;
        document.body.style.top = this.bodyTop;
        document.body.style.width = this.bodyWidth;
        window.scrollTo(0, this.scrollY);
      }
    }

    customElements.define('yg-splash-screen-v2', YGSplashScreen);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-video-list-01"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", ()=>{
    class YGVideoList01 extends HTMLElement {
        constructor() {
            super();
            this.playbackMode = this.getAttribute('data-playback-mode');
            this.slideItems = this.querySelectorAll('.yg-slide-item');
            this.handleClickPlayback = this.handleClickPlayback.bind(this);
        }
        connectedCallback() {
            if (this.playbackMode === 'click') {
                this.addEventListener('click', this.handleClickPlayback, true);
            }

            if (this.playbackMode === 'hover' && window.innerWidth > 1024) {
                this.initHoverPlayback();
            }
        }

        disconnectedCallback() {
            this.removeEventListener('click', this.handleClickPlayback, true);
        }

        handleClickPlayback(event) {
            const target = event.target instanceof Element ? event.target : null;
            const playButton = target ? target.closest('.yg-play') : null;
            if (!playButton || !this.contains(playButton)) return;

            const currentVideo = playButton.closest('yg-video');
            if (!currentVideo || !this.contains(currentVideo)) return;

            this.pauseOtherVideos(currentVideo);
        }

        pauseOtherVideos(currentVideo) {
            this.querySelectorAll('yg-video').forEach((videoEl) => {
                if (videoEl === currentVideo || typeof videoEl.pauseVideo !== 'function') return;
                videoEl.pauseVideo();
            });
        }

        initHoverPlayback() {
            this.slideItems.forEach(item => {
                const videoEl = item.querySelector('yg-video');
                if (!videoEl) return;

                item.addEventListener('mouseenter', () => {
                    if (videoEl.playVideo) {
                        videoEl.playVideo();
                    }
                });

                item.addEventListener('mouseleave', () => {
                    if (videoEl.pauseVideo) {
                        videoEl.pauseVideo();
                    }
                });
            });
        }
    }
    if (!window.customElements.get('yg-video-list-01')) {
        window.customElements.define('yg-video-list-01', YGVideoList01);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
